import { render, staticRenderFns } from "./AssetHistoricalMetrics.vue?vue&type=template&id=1e8db4c6&"
import script from "./AssetHistoricalMetrics.vue?vue&type=script&lang=ts&"
export * from "./AssetHistoricalMetrics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports